<template>
  <div id="weeklyReport" element-loading-background="rgba(255, 255, 255, 0.4)">
    <el-form :model="weeklyReportForm" ref="weeklyReportForm" label-width="190px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="Overall Project Progress:" prop="overallProgress" :rules="[{ required: true, message: 'Please input'}]">
            <el-input type="textarea" clearable v-model="weeklyReportForm.overallProgress" :rows="3" maxlength="255" placeholder="Please input" />
          </el-form-item>
        </el-col>
      </el-row>
      <div style="text-align: right; padding-top: 10px">
        <el-button type="primary" size="small" :loading="confirmLoading" @click="confirmWeekly('confirmLoading')">Confirm</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import moment from 'moment';
  export default {
    name: 'weeklyReport',
		props: {
			id: {
        type: Number,
        default: null,
      },
		},
    created () {
      this.getWeeklyInfo();
    },
    data () {
      return {
        moment,
        activeNames: ['1', '2', '3', '4', '5', '6'],
        weeklyReportForm: {},
        confirmLoading: false,
      }
    },
    methods: {
			getWeeklyInfo() {
        let url =`${this.$store.state.islhurl}majorProjectWeeklyReport/getByMajorProjectId?majorProjectId=${this.id}&&islhToken=${sessionStorage.getItem('islhtoken')}`;
        this._post(url).then(
          res => {  
            if(res && res.data) {
              this.weeklyReportForm = {
                ...res.data,
              }
              this.$nextTick(() => {
                this.$refs.weeklyReportForm.clearValidate();
              });
            }
          }
        )
			},
      confirmWeekly(loading) {
        this.$refs.weeklyReportForm.validate((valid) => {
					if (valid) {
            let params = {
              ...this.weeklyReportForm,
              majorProjectId: this.id,
					    islhToken: sessionStorage.getItem('islhtoken'),
            }
						let url =`${this.$store.state.islhurl}majorProjectWeeklyReport/edit`;
						this[loading] = true;
						this._post(url, params).then(
							res => {
                this[loading] = false;
								if(res.code === 200) {
									this.$Message.success('Successful!' );
                  this.getWeeklyInfo();
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
							}
						)
					}
				});
      },
    },
  }
</script>
<style lang="less" scoped>
#weeklyReport {
	.el-form {
		padding: 0 0 20px 0;
		/deep/.el-input {
			max-width: 350px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 12px;
		}
		/deep/.el-input-number {
			width: 100%;
			.el-input__inner {
				text-align: left;
			}
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
			max-width: 350px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/projectProgress/index.vue